import type { WrapUpTimeEndedUseCase } from '@usecases/wrap-up-time-ended.usecase';
import type { BaseController } from '@infra/controllers/base.controller';

export class WrapUpTimeEndedController implements BaseController<void> {
  constructor(private usecase: WrapUpTimeEndedUseCase) {}

  async handle() {
    return this.usecase.run();
  }
}
